/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Embed_Captions_Upload_FailedInputs */

const en_embed_captions_upload_failed = /** @type {(inputs: Embed_Captions_Upload_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to upload video file: ${i?.error}`)
};

const fr_embed_captions_upload_failed = /** @type {(inputs: Embed_Captions_Upload_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec du televersement du fichier video : ${i?.error}`)
};

const de_embed_captions_upload_failed = /** @type {(inputs: Embed_Captions_Upload_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Videodatei konnte nicht hochgeladen werden: ${i?.error}`)
};

const it_embed_captions_upload_failed = /** @type {(inputs: Embed_Captions_Upload_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile caricare il file video: ${i?.error}`)
};

const ru_embed_captions_upload_failed = /** @type {(inputs: Embed_Captions_Upload_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось загрузить видеофайл: ${i?.error}`)
};

const es_embed_captions_upload_failed = /** @type {(inputs: Embed_Captions_Upload_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudo cargar el archivo de vídeo: ${i?.error}`)
};

const zh_cn2_embed_captions_upload_failed = /** @type {(inputs: Embed_Captions_Upload_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`视频文件上传失败：${i?.error}`)
};

const ja_embed_captions_upload_failed = /** @type {(inputs: Embed_Captions_Upload_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ビデオファイルのアップロードに失敗しました: ${i?.error}`)
};

const hi_embed_captions_upload_failed = /** @type {(inputs: Embed_Captions_Upload_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`वीडियो फ़ाइल अपलोड करने में विफल: ${i?.error}`)
};

const pt_pt2_embed_captions_upload_failed = /** @type {(inputs: Embed_Captions_Upload_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao carregar o arquivo de vídeo: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to upload video file: {error}" |
*
* @param {Embed_Captions_Upload_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_upload_failed = /** @type {((inputs: Embed_Captions_Upload_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Upload_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_upload_failed(inputs)
	if (locale === "de") return de_embed_captions_upload_failed(inputs)
	if (locale === "it") return it_embed_captions_upload_failed(inputs)
	if (locale === "ru") return ru_embed_captions_upload_failed(inputs)
	if (locale === "es") return es_embed_captions_upload_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_upload_failed(inputs)
	if (locale === "ja") return ja_embed_captions_upload_failed(inputs)
	if (locale === "hi") return hi_embed_captions_upload_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_upload_failed(inputs)
	return en_embed_captions_upload_failed(inputs)
});